export class ShowSectorsUseCase{
    constructor(repository) {
      this.repository = repository
    }
    async execute(){
      const sectors=await this.repository.show()
      return sectors
    }
  }
